document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('li[role="tab"]').forEach(li => {
    li.addEventListener('click', () => {
      const link = li.querySelector('a');
      if (link) link.click();
    });
  });


  const blogPosts = document.querySelectorAll('.ds-blog-post-card');
  const navButtons = document.querySelectorAll('.ds-blog-posts-nav-buttons');
  
  function filterPosts(tag) {
      let visibleCount = 0;
      blogPosts.forEach(post => {
          if (tag === 'all' || post.getAttribute('data-collection-tag') === tag) {
              if (visibleCount < 10) {
                  post.style.display = '';
                  visibleCount++;
              } else {
                  post.style.display = 'none';
              }
          } else {
              post.style.display = 'none';
          }
      });
  }
  
  function updateButtons(activeButton) {
      navButtons.forEach(button => {
          button.classList.add('button--secondary');
      });
      activeButton.classList.remove('button--secondary');
  }
  
  function handleButtonClick(event) {
      event.preventDefault();
      const clickedButton = event.currentTarget;
      const tag = clickedButton.getAttribute('data-collection-tag');
      filterPosts(tag);
      updateButtons(clickedButton);
  }
  
  navButtons.forEach(button => {
      button.addEventListener('click', handleButtonClick);
  });
  
  if (navButtons.length > 0) {
      const firstButton = navButtons[0];
      const initialTag = firstButton.getAttribute('data-collection-tag');
      filterPosts(initialTag);
      updateButtons(firstButton);
  }  

});